import type { ApiPageInitResponse } from '@/infrastructure/api-functions/core-drafting-api/page-init-api';

/**
 * 分享页面服务
 */
export interface SharePageService {
    /**
     * 任务ID
     */
    readonly taskId: string;
    /**
     * 分享ID
     */
    readonly shareId: string;
    /**
     * 是否是分享页面
     */
    readonly isSharePage: boolean;
    /**
     * 是否是通过 sh_* 任务标识访问的 V2 分享页面
     */
    readonly isV2SharePage: boolean;
    /**
     * 页面权限配置代理,如果是分享页面,则返回mock值
     */
    pageInitProxy(): Promise<ApiPageInitResponse>;
    /**
     * 初始化,需要在页面渲染前调用,去将shareId换taskId
     */
    initialize(): Promise<void>;
}
export const SharePageService = Symbol('SharePageService');
